import React from 'react'
import { twMerge } from 'tailwind-merge'

export type RadioOption<T> = {
  label: string
  value: T
}

type RadioGroupProps<T> = {
  options: RadioOption<T>[]
  value: T
  onChange: (value: T) => void
  className?: string
}

export const RadioGroup = <T extends string>({
  options,
  value,
  onChange,
  className = '',
}: RadioGroupProps<T>) => {
  return (
    <div className={twMerge('flex items-center space-x-6 gap-6"', className)}>
      {options.map(option => (
        <label
          key={option.value}
          className="flex items-center gap-3 cursor-pointer text-L"
          onClick={() => onChange(option.value)}
        >
          <input
            type="radio"
            name="radio-group"
            value={option.value}
            checked={value === option.value}
            className="peer sr-only"
          />
          <div
            className={twMerge(
              'w-4 h-4 rounded-full bg-opacity-10 border border-borderInteractive flex justify-center items-center',
              value === option.value && 'bg-bgSecondary',
            )}
          >
            {value === option.value && (
              <div className="w-2 h-2 rounded-full bg-iconPrimary" />
            )}
          </div>
          <span className="text-textPrimary">{option.label}</span>
        </label>
      ))}
    </div>
  )
}
